<template>
  <main class="l-main p-config-contract">
    <TitleMain icon="config">
      <span class="title">ユーザー情報・各種設定</span>
    </TitleMain>
    <div class="l-container">
      <div class="l-toolBlock">
        <ButtonToProjects />
        <Breadcrumb />
      </div>
      <div class="l-block l-block--center">
        <TabConfig active="contract" />
        <div class="l-block__content">
          <div class="l-block__header">
            <TitleSub level="h3">利用情報</TitleSub>
          </div>
          <ContractOrganization v-if="isAuthority" class="l-mb-5" />
          <ContractProjects />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';
import ButtonToProjects from '@/components/ButtonToProjects';
import ContractOrganization from '@/components/config/ContractOrganization';
import ContractProjects from '@/components/config/ContractProjects';
import TabConfig from '@/components/config/TabConfig';
import TitleMain from '@/components/TitleMain';
import TitleSub from '@/components/TitleSub';

export default {
  components: {
    Breadcrumb,
    ButtonToProjects,
    ContractOrganization,
    ContractProjects,
    TabConfig,
    TitleMain,
    TitleSub
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    isAuthority() {
      return this.organization.isAuthority;
    }
  }
};
</script>
